import { Link, LinkProps } from 'components/lib';
import React, { ReactElement, ReactNode } from 'react';
import { Button, ButtonProps } from './Button';

export interface ButtonLinkProps
  extends LinkProps,
    Omit<ButtonProps, keyof LinkProps | 'onClick'> {
  children: ReactNode;
}

export const ButtonLink = ({ ...props }: ButtonLinkProps): ReactElement => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: see https://github.com/mui-org/material-ui/issues/7877
  return <Button component={Link} {...props} />;
};
